/* Standalone card: use the existing 72-hour design storage and recovery cache. */
(() => {
  const form = document.querySelector('[data-card-order]');
  if (!form) return;
  const input = form.querySelector('[data-card-upload]');
  const consent = form.querySelector('[data-card-consent]');
  const button = form.querySelector('button[type=submit]');
  const error = form.querySelector('[data-card-error]');
  const source = document.getElementById('design-image');
  const label = button.textContent;
  let artwork = null, objectUrl = '', revision = 0, busy = false, pending = false;
  const fail = message => { error.textContent = message; error.hidden = false; };
  const sync = () => { button.disabled = !!button.dataset.unavailable || button.hasAttribute('data-unavailable') || busy || pending || !artwork; };
  input.addEventListener('change', async () => {
    const token = ++revision;
    artwork = null; error.hidden = true; pending = true; sync();
    source.removeAttribute('src');
    if (objectUrl) URL.revokeObjectURL(objectUrl);
    const file = input.files[0];
    if (!file) { pending = false; sync(); return; }
    try {
      if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type) || file.size > 20 * 1024 * 1024) throw Error('file');
      const bitmap = await createImageBitmap(file);
      const scale = Math.min(1, 6000 / Math.max(bitmap.width, bitmap.height));
      const canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(bitmap.width * scale)); canvas.height = Math.max(1, Math.round(bitmap.height * scale));
      canvas.getContext('2d').drawImage(bitmap, 0, 0, canvas.width, canvas.height); bitmap.close();
      const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
      if (token !== revision) return;
      if (!blob) throw Error('decode');
      artwork = blob; objectUrl = URL.createObjectURL(blob); source.src = objectUrl;
    } catch (_) { if (token === revision) fail(form.dataset.fileError); }
    finally { if (token === revision) { pending = false; sync(); } }
  });
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (busy || pending || !artwork || !consent.checked || !form.reportValidity()) return;
    busy = true; sync(); input.disabled = true; consent.disabled = true;
    error.hidden = true; button.textContent = form.dataset.busy;
    try {
      const response = await fetch(form.dataset.worker + '/presign', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({folder: 'cart-full-images', contentType: 'image/png'}), signal: AbortSignal.timeout(15000)});
      if (!response.ok) throw Error('presign');
      const {uploadUrl, publicUrl} = await response.json();
      if (!uploadUrl || !publicUrl) throw Error('presign');
      const uploaded = await fetch(uploadUrl, {method: 'PUT', headers: {'Content-Type': 'image/png'}, body: artwork, signal: AbortSignal.timeout(30000)});
      if (!uploaded.ok) throw Error('upload');
      const key = 'card-' + crypto.randomUUID();
      if (!await window.RoboPixelDesignCache?.save(key, artwork, artwork, 'upload')) throw Error('backup');
      const result = await fetch(form.dataset.add, {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: [{id: Number(form.dataset.variant), quantity: 1, properties: {
        '_Design_Preview': publicUrl, '_Full_Image_URL': publicUrl, '_Design_Source': 'upload', '_Design_Cache_Key': key,
        '_Added_At': String(Date.now()), '_Metal_Card_Front': 'Uploaded artwork; centre crop to 54:86',
        '_Metal_Card_Back': 'RoboPixel Collectible v1 — 201 stainless steel, brushed, 86 × 54 × 0.9 mm', '_Photo_Upload_Terms': 'Accepted'
      }}]})});
      if (!result.ok) throw Error('cart');
      window.location.assign(form.dataset.cart);
    } catch (_) { fail(form.dataset.error); busy = false; input.disabled = consent.disabled = false; button.textContent = label; sync(); }
  });
})();
